import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const TELEFONOS_CONST = 'telefonos';

export const allTelefonosService = async (params) => {
  const res = await axios.get(`${baseUrl}/${TELEFONOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveTelefonosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${TELEFONOS_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${TELEFONOS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneTelefonosService = async (id) => {
  const res = await axios.get(`${baseUrl}/${TELEFONOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteTelefonosService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${TELEFONOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};
